import { Link, useLocation } from "react-router-dom";
import { HiChevronRight } from "react-icons/hi";

// { name: "Dashboard", path: "/dashboard" }

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const getBreadcrumbs = () => {
    let path = "";
    const crumbs = [{ name: "Home", path: "/dashboard" }];

    for (let i = 0; i < pathSegments.length; i++) {
      path += `/${pathSegments[i]}`;
      const name = pathSegments[i]
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      crumbs.push({ name, path });
    }
    return crumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <div className="flex justify-end text-sm text-white py-2 tracking-wider ">
      <div className="flex items-center gap-2">
        {breadcrumbs.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            {index > 0 && <HiChevronRight className="text-gray-400" />}
            <Link
              to={item.path}
              className="text-white dark:text-black hover:text-[#b99f6c] font-semibold capitalize"
            >
              {decodeURIComponent(item.name)}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumb;
